(function () {

  'use strict';

  if (window.DuonaCartDrawerV2) return;

  window.DuonaCartDrawerV2 = true;



  let lastTrigger = null;

  let requestInFlight = false;

  const drawer = () => document.getElementById('duona-cart-drawer');

  const overlay = () => document.getElementById('duona-cart-overlay');

  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  const cartUrl = (path) => root() + 'cart' + path;



  function ensureSingleInstance() {

    ['#duona-cart-drawer', '#duona-cart-overlay', '#duona-cart-toast'].forEach((selector) => {

      document.querySelectorAll(selector).forEach((element, index) => {

        if (index > 0) element.remove();

      });

    });

  }



  function lockPage() {

    const width = Math.max(0, window.innerWidth - document.documentElement.clientWidth);

    document.body.style.setProperty('--duona-scrollbar-width', width + 'px');

    document.body.classList.add('duona-cart-locked');

  }



  function unlockPage() {

    document.body.classList.remove('duona-cart-locked');

    document.body.style.removeProperty('--duona-scrollbar-width');

  }



  function openDrawer(trigger) {

    if (!drawer() || !overlay()) return;

    lastTrigger = trigger || document.activeElement;

    closeCompetingDrawers();

    lockPage();

    drawer().classList.add('active');

    overlay().classList.add('active');

    drawer().setAttribute('aria-hidden', 'false');

    overlay().setAttribute('aria-hidden', 'false');

    requestAnimationFrame(() => drawer().querySelector('.duona-cart-close')?.focus({ preventScroll: true }));

  }



  function closeCompetingDrawers() {

    document.querySelectorAll('cart-drawer,#CartDrawer,.cart-drawer,[data-cart-drawer]').forEach((element) => {

      if (element.id === 'duona-cart-drawer' || element.closest('#duona-cart-drawer')) return;

      try { if (typeof element.close === 'function') element.close(); } catch (error) {}

      element.removeAttribute('open');

      element.removeAttribute('active');

      element.classList.remove('active', 'animate', 'is-open', 'open');

      element.setAttribute('aria-hidden', 'true');

    });

  }



  function closeDrawer() {

    drawer()?.classList.remove('active');

    overlay()?.classList.remove('active');

    drawer()?.setAttribute('aria-hidden', 'true');

    overlay()?.setAttribute('aria-hidden', 'true');

    unlockPage();

    lastTrigger?.focus?.({ preventScroll: true });

  }



  function showToast(message) {

    const toast = document.getElementById('duona-cart-toast');

    if (!toast) return;

    const label = toast.querySelector('span');

    if (label) label.textContent = message || 'Item added to your cart';

    toast.classList.add('is-visible');

    clearTimeout(showToast.timer);

    showToast.timer = setTimeout(() => toast.classList.remove('is-visible'), 2600);

  }



  function updateHeaderCount(cart) {

    const count = Number(cart.item_count || 0);

    const badge = document.getElementById('duona-header-cart-count');

    if (badge) {

      badge.textContent = String(count);

      badge.hidden = count === 0;

      badge.toggleAttribute('hidden', count === 0);

      badge.classList.toggle('hidden', count === 0);

      badge.classList.toggle('is-empty', count === 0);

      badge.setAttribute('data-cart-count', String(count));

      badge.setAttribute('aria-label', `${count} ${count === 1 ? 'item' : 'items'} in cart`);

    }



    document.querySelectorAll('.header__icon--cart,a[href$="/cart"],a[href$="/cart/"]').forEach((node) => {

      node.classList.toggle('is-empty', count === 0);

      node.setAttribute('aria-label', `Cart, ${count} ${count === 1 ? 'item' : 'items'}`);

    });



    document.querySelectorAll('#duona-header-cart-total').forEach((node) => {

      node.hidden = count === 0;

      node.toggleAttribute('hidden', count === 0);

      node.classList.toggle('hidden', count === 0);

      if (window.Shopify && typeof Shopify.formatMoney === 'function') {

        node.textContent = '(' + Shopify.formatMoney(cart.total_price) + ')';

      } else {

        node.textContent = '(' + new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(cart.total_price / 100) + ')';

      }

    });

    document.dispatchEvent(new CustomEvent('duona:cart-updated', { detail: { cart } }));

  }



  async function getCart() {

    const response = await fetch(cartUrl('.js'), { headers: { Accept: 'application/json' }, credentials: 'same-origin' });

    if (!response.ok) throw new Error('Unable to load cart');

    return response.json();

  }



  async function refreshDrawer(shouldOpen, trigger) {

    const current = drawer();

    const sectionId = current?.dataset.sectionId;

    if (!current || !sectionId) throw new Error('Cart drawer section id is missing');

    const separator = location.search ? '&' : '?';

    const url = location.pathname + location.search + separator + 'section_id=' + encodeURIComponent(sectionId);

    const [html, cart] = await Promise.all([

      fetch(url, { credentials: 'same-origin' }).then((response) => {

        if (!response.ok) throw new Error('Unable to refresh cart drawer');

        return response.text();

      }),

      getCart()

    ]);

    const parsed = new DOMParser().parseFromString(html, 'text/html');

    const freshDrawer = parsed.getElementById('duona-cart-drawer');

    const freshOverlay = parsed.getElementById('duona-cart-overlay');

    if (!freshDrawer || !freshOverlay) throw new Error('Cart drawer markup was not returned');

    current.replaceWith(freshDrawer);

    overlay()?.replaceWith(freshOverlay);

    updateHeaderCount(cart);

    if (shouldOpen) openDrawer(trigger);

  }



  function loading(button, state) {

    if (!button) return;

    if (state) {

      button.dataset.duonaOldText = button.textContent;

      button.disabled = true;

      button.setAttribute('aria-busy', 'true');

      button.textContent = 'Adding...';

    } else {

      button.disabled = false;

      button.removeAttribute('aria-busy');

      button.textContent = button.dataset.duonaOldText || 'Add to cart';

    }

  }



  async function addForm(form, button) {

    if (requestInFlight) return;

    requestInFlight = true;

    loading(button, true);

    try {

      const response = await fetch(cartUrl('/add.js'), { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form), credentials: 'same-origin' });

      const result = await response.json();

      if (!response.ok) throw new Error(result.description || 'Add to cart failed');

      await refreshDrawer(true, button);

      showToast('Item added to your cart');

    } catch (error) {

      console.error('[Duona cart]', error);

      alert(error.message || 'Could not add this product. Please try again.');

    } finally {

      requestInFlight = false;

      loading(button, false);

    }

  }



  async function changeLine(key, quantity, trigger) {

    if (requestInFlight) return;

    requestInFlight = true;

    try {

      const response = await fetch(cartUrl('/change.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: Number(quantity) }), credentials: 'same-origin' });

      const result = await response.json();

      if (!response.ok) throw new Error(result.description || 'Cart update failed');

      await refreshDrawer(true, trigger);

    } catch (error) {

      console.error('[Duona cart]', error);

      alert(error.message || 'Could not update the cart. Please try again.');

    } finally {

      requestInFlight = false;

    }

  }



  async function cartPost(path, payload) {
    const response = await fetch(cartUrl(path), {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload),credentials:'same-origin'});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || 'Cart update failed');
    return result;
  }

  async function swapLine(button, undo = false) {
    if (requestInFlight) return;
    requestInFlight = true;
    const label = button.innerHTML;
    button.disabled = true;
    button.textContent = undo ? 'Restoring...' : 'Swapping...';
    let added = null;
    try {
      const currentCart = await getCart();
      const oldLine = currentCart.items.find(item => item.key === button.dataset.currentKey);
      if (!oldLine) throw new Error('Cart item changed. Please reopen cart.');
      const target = Number(undo ? button.dataset.originalVariant : button.dataset.swapVariant);
      if (!Number.isSafeInteger(target) || target <= 0) throw new Error('Invalid swap variant');
      const quantity = oldLine.quantity;
      // Add first, then remove: failed adds leave the original product untouched.
      const properties = undo ? {} : {_duona_original_variant:String(oldLine.variant_id)};
      added = await cartPost('/add.js', {id:target,quantity,properties});
      try {
        await cartPost('/change.js', {id:oldLine.key,quantity:0});
      } catch (removeError) {
        // Best-effort rollback of newly added quantity; never silently claim success.
        try { await cartPost('/change.js',{id:added.key,quantity:0}); } catch (_) {}
        throw removeError;
      }
      await refreshDrawer(true, button);
      showToast(undo ? 'Original product restored' : 'Product swapped successfully');
    } catch(error) {
      console.error('[Duona cart]',error);
      alert(error.message || 'Unable to swap product. Please try again.');
      try { await refreshDrawer(true, button); } catch (_) {}
    } finally {
      requestInFlight = false;
      button.disabled = false;
      button.innerHTML = label;
    }
  }

  document.addEventListener('submit', (event) => {

    const form = event.target.closest('form[action*="/cart/add"]');

    if (!form || !drawer()) return;

    event.preventDefault();

    event.stopImmediatePropagation();

    addForm(form, form.querySelector('[type="submit"],button[name="add"]'));

  }, true);



  document.addEventListener('click', (event) => {

    if (event.target.closest('.duona-cart-close,#duona-cart-overlay')) { event.preventDefault(); closeDrawer(); return; }

    const cartLink = event.target.closest('.cart-icon,.header__icon--cart,a[href$="/cart"],a[href$="/cart/"]');

    if (cartLink && !event.target.closest('.duona-view-cart-btn')) {

      event.preventDefault();

      event.stopImmediatePropagation();

      refreshDrawer(true, cartLink).catch((error) => { console.error('[Duona cart]', error); openDrawer(cartLink); });

      return;

    }

    const qty = event.target.closest('.duona-qty-btn');

    if (qty) { event.preventDefault(); changeLine(qty.dataset.key, qty.dataset.qty, qty); return; }

    const remove = event.target.closest('.duona-remove-btn');

    if (remove) { event.preventDefault(); changeLine(remove.dataset.key, 0, remove); return; }

    const swap = event.target.closest('.duona-swap-btn');

    if (swap) { event.preventDefault(); swapLine(swap); return; }
      const undo = event.target.closest('.duona-undo-btn');
      if (undo) { event.preventDefault(); swapLine(undo, true); }

  }, true);



  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && drawer()?.classList.contains('active')) closeDrawer(); });

  document.addEventListener('shopify:section:load', () => getCart().then(updateHeaderCount).catch(() => {}));

  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', () => { ensureSingleInstance(); getCart().then(updateHeaderCount).catch(() => {}); }, { once: true });

  } else {

    ensureSingleInstance();

    getCart().then(updateHeaderCount).catch(() => {});

  }

})();
